import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoayodhyacab() {



const cardData = {
  keyword: " Mumbai to Ayodhya Cab Package   ",

headingDescription: "Velocity Cab provides reliable and comfortable Mumbai to Ayodhya cab package services, ensuring a seamless and stress-free journey for pilgrims, families, and leisure travelers. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Mumbai to Ayodhya convenient and safe. The journey covers approximately 1,300–1,350 km via NH27 and NH330, typically taking 22–24 hours depending on traffic and road conditions. We offer flexible booking options including one-way trips, round trips, and customized cab packages with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Mumbai to Ayodhya cab travel.",

topPlaces: [
  {
    title: "Ram Janmabhoomi",
    description: "Ram Janmabhoomi is the sacred birthplace of Lord Ram in Ayodhya and the central pilgrimage site for devotees. Travelers from Mumbai can reach the site comfortably by cab, participate in religious ceremonies, and explore the newly developed temple complex."
  },
  {
    title: "Hanuman Garhi",
    description: "Hanuman Garhi is a historic temple dedicated to Lord Hanuman, located in the heart of Ayodhya. Visitors traveling by cab from Mumbai can climb the temple steps, witness rituals, and enjoy panoramic views of the city."
  },
  {
    title: "Kanak Bhawan",
    description: "Kanak Bhawan is a famous temple associated with Lord Ram and Goddess Sita. Travelers from Mumbai can visit this beautifully decorated temple by cab, admire the intricate carvings, and experience its spiritual ambiance."
  },
  {
    title: "Saryu River Ghats",
    description: "The Saryu River Ghats are a sacred riverside area in Ayodhya for devotional activities, holy dips, and religious rituals. Travelers arriving from Mumbai by cab can enjoy peaceful walks along the ghats, witness cultural ceremonies, and experience the spiritual atmosphere."
  },
  {
    title: "Treta Ke Thakur",
    description: "Treta Ke Thakur is a temple dedicated to Lord Ram, known for its ancient idols and religious significance. Visitors from Mumbai can reach the temple by cab, participate in prayers, and explore the historic structures."
  },
  {
    title: "Guptar Ghat",
    description: "Guptar Ghat is a sacred ghat along the Saryu River, historically significant for devotees of Lord Ram. Travelers from Mumbai can visit comfortably by cab, enjoy serene surroundings, and perform religious rituals."
  },
  {
    title: "Nageshwarnath Temple",
    description: "Nageshwarnath Temple is an ancient Shiva temple in Ayodhya with historical and spiritual importance. Visitors traveling by cab from Mumbai can explore the temple, observe traditional rituals, and appreciate its architectural beauty."
  },
  {
    title: "Ram Katha Park",
    description: "Ram Katha Park is a modern recreational and spiritual park in Ayodhya celebrating the life and teachings of Lord Ram. Travelers from Mumbai can visit by cab, enjoy landscaped gardens, informative exhibits, and peaceful surroundings."
  },
  {
    title: "Sugriv Parvat",
    description: "Sugriv Parvat is a scenic hill in Ayodhya associated with Ramayana legends. Visitors from Mumbai can reach this spot by cab, enjoy panoramic views, and explore the historical significance linked to Lord Ram."
  },
  {
    title: "Chandrawati Ghat",
    description: "Chandrawati Ghat is a sacred riverside location near the Saryu River known for rituals and spiritual activities. Travelers using cab services from Mumbai can visit the ghat comfortably, witness traditional ceremonies, and enjoy the serene environment."
  }
],



services: [
{
name: "Mumbai to Ayodhya Cab Service",
description: "Mumbai to Ayodhya cab service offers a comfortable and spiritually fulfilling long-distance journey for devotees and travelers visiting the sacred city of Lord Ram. Ayodhya is one of the most important religious destinations in India, attracting pilgrims throughout the year. This service is ideal for those who prefer a private and flexible road trip from Mumbai to Ayodhya without the hassle of public transport. The journey covers multiple states with smooth highway connectivity, ensuring a continuous and relaxed drive. Professional drivers experienced in long-distance and interstate travel ensure safety, proper rest stops, and timely arrival. Customers can choose from sedan, SUV, and premium vehicles depending on their comfort and group size. Doorstep pickup in Mumbai and direct drop at temples, hotels, or residences in Ayodhya ensures complete convenience. With transparent pricing, easy booking, and 24x7 availability, this cab service guarantees a hassle-free and comfortable pilgrimage experience."
},
{
name: "Mumbai to Ayodhya Taxi",
description: "Mumbai to Ayodhya taxi service provides reliable and comfortable transportation for long-distance interstate travel. This service is ideal for pilgrims, families, and business travelers who prefer a private journey with flexible timing. Vehicles are well-maintained with clean interiors and comfortable seating for long hours of travel. Drivers are experienced in interstate routes ensuring safe and efficient driving. Multiple vehicle options such as sedan and SUV are available to suit different budgets. Flexible pickup options across Mumbai make travel convenient. It ensures a smooth and stress-free journey experience."
},
{
name: "Mumbai to Ayodhya Cab Booking",
description: "Mumbai to Ayodhya cab booking allows customers to reserve their cab quickly with instant confirmation and flexible scheduling. Travelers can select vehicle type, pickup location, and travel date according to their needs. Transparent pricing ensures there are no hidden charges during the journey. Online booking platforms provide secure payment options and real-time availability. Dedicated customer support is available to assist at every step. It is the most convenient way to plan a long-distance pilgrimage trip. It ensures a smooth and organized travel experience."
},
{
name: "Ayodhya Tour Package from Mumbai by Cab",
description: "Ayodhya tour package from Mumbai by cab offers a complete and well-planned travel experience covering major religious attractions in Ayodhya. This package is ideal for devotees who want a comfortable and organized pilgrimage journey. It includes pickup from Mumbai, travel to Ayodhya, and local sightseeing at important temples and ghats. Travelers can customize their itinerary and duration based on their preferences. Professional drivers ensure safe and smooth travel across long routes. Comfortable vehicles enhance the journey experience. It provides a complete and convenient pilgrimage solution."
},
{
name: "Mumbai to Ayodhya Outstation Cab",
description: "Mumbai to Ayodhya outstation cab service provides dependable intercity travel with comfort and safety. This service is suitable for pilgrims, families, and group travelers. Vehicles are well-maintained for long-distance highway travel. Flexible options include one way and round trip packages. Professional drivers ensure safe navigation and timely arrival. Pickup from multiple locations across Mumbai adds convenience. It ensures a hassle-free and comfortable journey experience."
},
{
name: "Mumbai to Ayodhya Taxi Fare",
description: "Mumbai to Ayodhya taxi fare is designed to be transparent and competitive, helping travelers plan their journey efficiently. Pricing depends on vehicle type, distance, and trip duration. Customers receive a detailed breakdown of charges including tolls and driver allowance where applicable. Affordable options are available for sedan, SUV, and premium vehicles. No hidden charges ensure trust and reliability. Flexible pricing options suit different budgets. It offers excellent value for long-distance travel."
},
{
name: "Cheap Cab Mumbai to Ayodhya",
description: "Cheap cab Mumbai to Ayodhya offers budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers and pilgrims seeking reliable transportation. Sedan vehicles provide economical pricing for long-distance journeys. Transparent billing ensures no hidden charges. Professional drivers ensure safe and smooth travel. Flexible booking options make planning easy. It is a perfect choice for affordable travel."
},
{
name: "Mumbai to Ayodhya SUV Taxi",
description: "Mumbai to Ayodhya SUV taxi is ideal for families and groups who require extra space and comfort during long-distance travel. SUVs provide spacious seating and better performance across highways. This option is suitable for long journeys with luggage and multiple passengers. Professional drivers ensure safe and comfortable driving throughout the trip. It offers a premium travel experience. Perfect for group travel. It ensures a smooth and enjoyable ride."
},
{
name: "Mumbai to Ayodhya Sedan Cab",
description: "Mumbai to Ayodhya sedan cab is a popular choice for individuals, couples, and small families seeking a comfortable and economical ride. Sedans offer smooth travel, good mileage, and comfortable seating for long-distance journeys. This service is ideal for budget-friendly travel without compromising convenience. Professional drivers ensure safe and efficient driving. Flexible pickup options enhance convenience. It ensures a pleasant and comfortable journey."
},
{
name: "Private Cab Mumbai to Ayodhya",
description: "Private cab Mumbai to Ayodhya offers a personalized travel experience with exclusive vehicle usage for passengers. Travelers can customize routes, stops, and travel schedules according to their preferences. This ensures a relaxed and stress-free journey across long distances. Professional drivers provide safe and reliable service with complete privacy. Comfortable seating and premium service enhance the experience. It is ideal for private and luxury travel. It guarantees flexibility and comfort."
},
{
name: "AC Taxi Mumbai to Ayodhya",
description: "AC taxi Mumbai to Ayodhya ensures a comfortable journey in air-conditioned vehicles for long-distance interstate travel. This service provides a cool and pleasant environment throughout the journey. Clean interiors and well-maintained AC systems enhance passenger comfort. Suitable for families, tourists, and business travelers. Flexible booking options make travel planning easy. Professional drivers ensure timely service. It guarantees a relaxing and smooth journey experience."
}
],

tableData: [
["Mumbai to Ayodhya Cab Service","Mumbai to Ayodhya Taxi"],
["Mumbai to Ayodhya Cab Booking","Ayodhya Tour Package from Mumbai by Cab"],
["Mumbai to Ayodhya Outstation Cab","Mumbai to Ayodhya Taxi Fare"],
["Cheap Cab Mumbai to Ayodhya","Mumbai to Ayodhya SUV Taxi"],
["Mumbai to Ayodhya Sedan Cab","Private Cab Mumbai to Ayodhya"],
["AC Taxi Mumbai to Ayodhya","Mumbai to Ayodhya Cab Service"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Religious Travel Package",
    WhyChoosedescription: "Velocity Cabs offers Mumbai to Ayodhya cab packages designed for a peaceful and comfortable journey, ideal for devotees traveling to Shri Ram Janmabhoomi and other sacred places."
  },
  {
    WhyChooseheading: "Experienced Long Route Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in long-distance routes from Mumbai to Ayodhya, ensuring safe driving, proper navigation, and timely arrival."
  },
  {
    WhyChooseheading: "Transparent Package Pricing",
    WhyChoosedescription: "Velocity Cabs provides clear and transparent pricing for Mumbai to Ayodhya cab packages. Customers receive full fare details including toll charges and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Mumbai to Ayodhya cab service operates 24/7. Whether you plan early departure or overnight travel, we ensure reliable service anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, and multi-day Ayodhya darshan packages."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, and group pilgrimage travel."
  },
  {
    WhyChooseheading: "Trusted Pilgrimage Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many devotees for Mumbai to Ayodhya cab bookings due to punctual drivers, clean vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide Mumbai to Ayodhya cab package?", answer: "Yes, Velocity Cabs provides complete cab packages from Mumbai to Ayodhya for pilgrimage travel." },
  { question: "How far is Ayodhya from Mumbai?", answer: "The distance between Mumbai and Ayodhya is approximately 1450 to 1600 km and travel time is around 24 to 28 hours depending on route and traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Ayodhya cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services from Mumbai to Ayodhya." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab package online?", answer: "Yes, customers can easily book Mumbai to Ayodhya cab packages online or through phone booking." },
  { question: "Do you provide darshan packages?", answer: "Yes, we provide customized Ayodhya darshan packages including temple visits and local sightseeing." },
  { question: "Is advance booking required?", answer: "Yes, advance booking is highly recommended for long-distance pilgrimage routes like Ayodhya." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rajesh Sharma",
    feedback:
      "A long but very comfortable journey from Mumbai to Ayodhya. The cab was well-maintained, and the ride felt safe and smooth throughout the entire trip.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sunita Verma",
    feedback:
      "The Mumbai to Ayodhya cab service was reliable and well-organized. The vehicle was clean, the drive was steady, and the overall travel experience was peaceful.",
    rating: 5
  }
];






















const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];










const mumbaiAyodhyaCabJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Mumbai to Ayodhya Cab Package | Velocity Cabs",
  "description": "Book a private cab from Mumbai to Ayodhya for comfortable outstation travel. AC, Sedan, and SUV taxis available for one-way or round trips at affordable fares.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mumbai, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Mumbai to Ayodhya Cab Packages",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "One Way Cab from Mumbai to Ayodhya",
        "description": "Private cab from Mumbai to Ayodhya for one-way travel with AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip Mumbai to Ayodhya Cab",
        "description": "Comfortable round-trip cab service from Mumbai to Ayodhya with private AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};








  return (
    <div>
      
<Helmet>
  <title>Mumbai to Ayodhya Cab Package | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book a private cab from Mumbai to Ayodhya for comfortable outstation travel. AC, Sedan, and SUV taxis available for one-way or round trips at affordable fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(mumbaiAyodhyaCabJSON)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/100.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoayodhyacab;